import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { toast } from 'react-toastify';
import { updateSupportEmailReplied } from '../../firebase/emailsupports';
import { useAuth } from '../../context/authContext';

const DialogReplyEmail = ({ open, onClose, emailData, onReplySent }) => {
    const [replyMessage, setReplyMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const { user } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!replyMessage.trim()) {
            toast.error('Please enter a reply message');
            return;
        }

        setLoading(true);
        try {
            // Send email using emailjs
            const templateParams = {
                title: `Reply to your support request: ${emailData.message.substring(0, 20)}...`,
                to_email: emailData.reply_to,
                from_name: 'CardMarket Support',
                reply_to: 'contact@cardshopexchange.com', // Adjust as needed
                message: replyMessage,
                original_message: emailData.message,
                to_name: emailData.from_name,
            };
            //created by dong@kovsk.com
            await emailjs.send('service_i9vn4ai', 'template_reply', templateParams, 'Z7afe3kOZttPkl4jW'); // Adjust service/template IDs
                
            // Update the replied status in database
            const replierInfo = {
                uid: user?.uid,
                displayName: user?.displayName || user?.email?.split('@')[0] || 'Unknown',
                email: user?.email
            };
            await updateSupportEmailReplied(emailData.id, true, replyMessage, new Date(), replierInfo);

            toast.success('Reply sent successfully');
            onReplySent();
            onClose();
            setReplyMessage('');
        } catch (error) {
            console.error('Error sending reply:', error);
            toast.error('Failed to send reply');
        } finally {
            setLoading(false);
        }
    };

    if (!open) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-[#1D1D1D] p-6 rounded-lg w-full max-w-2xl">
                <h2 className="text-white text-lg font-bold mb-4">Reply to Support Email</h2>
                <div className="mb-4">
                    <p className="text-gray-400 text-sm">From: {emailData.from_name} ({emailData.senderEmail})</p>
                    <p className="text-gray-400 text-sm">Reply To: {emailData.reply_to}</p>
                    <p className="text-gray-400 text-sm">Original Message:</p>
                    <p className="text-white bg-[#2E2E2E] p-2 rounded mt-1">{emailData.message}</p>
                </div>
                <form onSubmit={handleSubmit}>
                    <textarea
                        className="w-full p-2 bg-[#2E2E2E] text-white rounded mb-4"
                        rows="4"
                        placeholder="Enter your reply..."
                        value={replyMessage}
                        onChange={(e) => setReplyMessage(e.target.value)}
                    />
                    <div className="flex justify-end space-x-2">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 bg-gray-600 text-white rounded hover:bg-gray-700"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            disabled={loading}
                            className="px-4 py-2 bg-primary text-white rounded hover:bg-blue-600 disabled:opacity-50"
                        >
                            {loading ? 'Sending...' : 'Send Reply'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default DialogReplyEmail;